import JoinPublisher from 'features/join/publisher/JoinPublisher';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import JoinAudience from 'features/join/audience/JoinAudience';
import { useAppSelector } from 'store/hooks';
import { selectJoinScreenEnabled } from 'features/room/roomSlice';
import FastJoin from 'features/join/fast-join/FastJoin';
import BrandedLayout from 'layouts/BrandedLayout';
import { ToastContainer } from 'features/notifications/toast/ToastContainer';
import { advancedToastTransition } from 'features/notifications/toast/transitions';
import { JOIN_NOTIFICATION_CONTAINER_ID } from 'features/notifications/constants';

const JoinScreen = () => {
  const joinScreenEnabled = useAppSelector(selectJoinScreenEnabled);

  const { hasPermissions } = usePermissions();

  const allowBroadcast = hasPermissions(
    [PermissionTypes.broadcastVideo, PermissionTypes.broadcastAudio],
    {
      mode: 'any',
    }
  );

  const renderContent = () => {
    if (joinScreenEnabled) {
      if (allowBroadcast) {
        return <JoinPublisher />;
      }

      return <JoinAudience />;
    }

    return <FastJoin />;
  };

  return (
    <BrandedLayout>
      {renderContent()}
      <ToastContainer
        colorTheme="light"
        transition={advancedToastTransition}
        position="top-center"
        autoClose={false}
        hideProgressBar
        newestOnTop
        pauseOnFocusLoss={false}
        draggable={false}
        closeButton={false}
        toastClassName="action-toast"
        className="join-toast-container"
        containerId={JOIN_NOTIFICATION_CONTAINER_ID}
      />
    </BrandedLayout>
  );
};

export default JoinScreen;
